import {Injectable} from '@angular/core';
import {RegistrationRequest} from '../model/registration-request.model';
import {AsyncSubject} from 'rxjs';
import {RegistrationApi} from '../api/registration.api';
import {ValidatedRegistrationToken} from '../model/validated-registration-token.model';

@Injectable()
export class RegistrationService {
    constructor(private registrationApi: RegistrationApi) { }

    getProfileRegex = () => this.registrationApi.getProfileRegex();

    validateToken(token: string) {
        let response = new AsyncSubject();

        this.registrationApi
            .validateToken(token)
            .subscribe(data => {
                response.next(data);
                response.complete();
            }, () => {
                let token: ValidatedRegistrationToken = new ValidatedRegistrationToken();
                response.next(token);
                response.complete();
            });

        return response;
    }
    
    validateTokenAndEmail = (token: string, email: string) => this.registrationApi.validateTokenAndEmail(token, email);

    registerNewUser = (registrationRequest: RegistrationRequest) => this.registrationApi.registerNewUser(registrationRequest);

    registerExistingUser = (registrationRequest: RegistrationRequest) => this.registrationApi.registerExistingUser(registrationRequest);

    verifyRegistration = (verificationToken: string) => this.registrationApi.verifyRegistration(verificationToken);
}